/**
 * @param touchedFields object - { email: true, password: false }
 * @returns bool
 */
export default function hasTouchedField(touchedFields = {}) {
  return !!Object.values(touchedFields).find((fieldValue) => fieldValue === true);
}
